import React from "react";
import { Accordion, Card, Container, Row, Col } from "react-bootstrap";
import t1 from "../../assets/images/t1.png";
import t2 from "../../assets/images/t2.png";
import t3 from "../../assets/images/t3.png";
import t4 from "../../assets/images/t4.png";
import t5 from "../../assets/images/t5.png";
import t6 from "../../assets/images/t6.png";
import t7 from "../../assets/images/t7.png";
import t8 from "../../assets/images/t8.png";
import t9 from "../../assets/images/t9.png";
import b1 from "../../assets/images/c1.png";
import b2 from "../../assets/images/c2.png";
import b3 from "../../assets/images/c3.png";
import b4 from "../../assets/images/c4.png";
import b5 from "../../assets/images/c5.png";
import b6 from "../../assets/images/c6.png";
import b7 from "../../assets/images/c7.png";
import b8 from "../../assets/images/c8.png";
import b10 from "../../assets/images/RaceXbanner1.png";
import b11 from "../../assets/images/RaceXbanner2.png";
import homeLogo from "../../assets/images/RaceXbanner1.png";
import Particle from "../Particle"; 
import Button from "react-bootstrap/Button";
import { BiLinkExternal } from "react-icons/bi";
import rp from "../../assets/images/dcrclogo.png";
import { FaTelegramPlane, FaDiscord, FaTwitter } from "react-icons/fa";
import { Chrono } from "react-chrono";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {Carousel} from '3d-react-carousal';
import ScrollToTop from "../ScrollToTop";
import AccordionDisplay from "./Accordion";
import Footer from "../Footer";
import ReactPlayer from 'react-player';
import introvid from "../../assets/images/introvid.mp4"; 


function faq() {


  return (
    <section>
      <Container fluid className="home-section" id="#">
        <Container className="home-content">
        <Row style={{ justifyContent: "center"}}>
          <Col xl={12} style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <img src={homeLogo} width="100%" className="home-img" alt="home pic"/>
          </Col>
          </Row>
          <Row id="faq-section" style={{ justifyContent: "center", paddingTop: "10px", paddingBottom: "20px" }}></Row>

          <div style={{ borderTop: "4px solid red ", marginLeft: 20, marginRight: 20 }}>
          </div>

          <Row style={{ paddingTop:"70px", paddingBottom: "30px", justifyContent: "center" }}>
            <h1 className="home-heading">
              <strong className="white">FAQs</strong>
            </h1>
          </Row>
          <Row >
          <Col md={12}  >
         <AccordionDisplay 
           title="What is DCRC.RACING"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
                We are the first Racing Sim ecosystem to offer both real world and virtual motor racing. All of this on the most amazing Blockchain of them all.
           </div>
         </AccordionDisplay>
         <AccordionDisplay 
           title="Why Avalanche?"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
                Avalanche is a very exciting network, with fast transaction times and reasonable fees. We need a highly scalable platform for our fast moving racing game ... <br/>
                Avalanche has it all
           </div>
         </AccordionDisplay>
         <AccordionDisplay 
           title="When are you launching ?"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
                The website will be live in October 2021, as well as the $RACE Token.
                <br/>
                NFT Series 1 goes on sale after at the end of October 2021. During November 2021
           </div>
         </AccordionDisplay>
         <AccordionDisplay 
           title="How much to buy one?"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
                NFT Series 1 Minting Price TBA.
           </div>
         </AccordionDisplay>
          <AccordionDisplay 
           title="How many Cars I am allowed to mint?"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
                There's a max of 20 Mints applied per transaction. All Cars will be placed in a random generation sequence and their rarity is pure luck!
                <br/>
           </div>
         </AccordionDisplay>
          <AccordionDisplay 
           title="Can I upgrade my NFT"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
                Yes, These NFTs are fully upgradeable interms of both cosmetics and performance upgrades.
           </div>
         </AccordionDisplay>
          <AccordionDisplay 
           title="How can I see what I actually bought?"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
                Once you mint, you can take a look at your NFTs through the website and the "My Garage" section.
           </div>
         </AccordionDisplay>
          <AccordionDisplay 
           title="Can I trade DCRC Race NFTs?"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
                Yes you can. They can be traded through NFT Marketplaces as well as our own soon to be developed market place (Motor Dealership)!
           </div>
         </AccordionDisplay>
          <AccordionDisplay 
           title="Is there a roadmap on this thing?"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
                Well...you could take a look at our Roadmap section on our Discord Community, as well as through our website.
           </div>
         </AccordionDisplay>
          <AccordionDisplay 
           title="Are there Royalties applied on these NFT?"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
               DCRC owners hold copyrights of their individual NFTs, stored permanently on IPFS. There will be a 7% Royalty on each mint, 4% will go to the Dev Wallet and 3% will reflected to the owners of the DCRC Cars.
           </div>
         </AccordionDisplay>
          <AccordionDisplay 
           title="How can I contact you?"
           arrowPosition="left"
           forceDefaultHide={true}
          >
           <div>
               We are always available to our Community through Discord and telegram and are more than happy to answer your questions.
           </div>
         </AccordionDisplay>
          </Col>
          </Row>
          <Row id="team-section" style={{ justifyContent: "center", paddingTop: "50px", paddingBottom: "20px" }}></Row>
          <Footer />
        </Container>
      </Container>
    </section>
  );
}

export default faq;
